module.exports = __webpack_public_path__ + "media/images/v1/circle-b8db6950ad96467b39f61f6d42c91d2c.png";